import { Center as BriqCommonCenter } from '@briq/shared'

export const centerChildrenMixin = BriqCommonCenter.centerChildrenMixin

export const CenterChildren = BriqCommonCenter.CenterChildren
